import xw from 'xwind';
import styled from '@emotion/styled';

export default styled.section(xw`w-full`);
